import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import { siteChange } from '../profile/actions';
import * as actions from './actions';
import { SupplierDetailsState } from './types';

export const initialState: SupplierDetailsState = {
    supplierDetails: [],
};

const SlaughterHouseSupplierDetailsReducer = (state: SupplierDetailsState = initialState, action: Action): SupplierDetailsState => {
    if (isType(action, actions.getSupplierDetails.done)) {
        const result = { ...state, supplierDetails: action.payload.result };
        return result;
    }
    if(isType(action, actions.postSupplierDetails.done)){
        const result = action.payload.result
        const connectionsCopy = [...state.supplierDetails]
        const index = connectionsCopy.findIndex(c=> c.id === result.id);
        if(index>= 0){
            connectionsCopy[index] =result;

        }else{
            connectionsCopy.push(result)
        }
        return {...state, supplierDetails: [...connectionsCopy]}
    }

    if (isType(action, actions.AddSupplier)) {
		state = { ...state, supplierDetails: [...state.supplierDetails,action.payload] };
	}
    if (isType(action, siteChange.done)) {
		state = initialState;
	}

    return state;
};

export default SlaughterHouseSupplierDetailsReducer;
